import { MarkoutApiService } from './service/MarkoutApiService';

export const markoutApiService: MarkoutApiService = new MarkoutApiService();
